<div class="container">
  <hyperkit-typography
    class="page-title"
    display="block"
    variant="h1"
    align="left"
    color="primary"
    >API Keys</hyperkit-typography
  >
  <div class="api-keys-wrapper">
    <div>
      <hyperkit-typography
        display="inline"
        variant="body"
        size="md"
        align="left"
        color="primary"
        >Create up to {{ keyLimit }} API Keys that can be used to access HUNTER
        services and content. Learn more in our</hyperkit-typography
      ><hyperkit-link
        display="inline"
        [href]="apiDocUrl"
        target="_blank"
        variant="body"
        size="md"
        color="secondary"
        align="left"
        text="Intel 471 HUNTER API Documentation."
      ></hyperkit-link>
    </div>
    @if (apiKeys$ | async; as apiKeys) {
      <div>
        <div>
          @if (apiKeys.keys.length < keyLimit) {
            <form>
              <hyperkit-input
                #keyName
                class="hyperkit-component"
                type="text"
                label="Create API Key"
                placeholder="Key Name"
              ></hyperkit-input>
              <hyperkit-button
                [disabled]="!keyName.value || keyName.value.length < 0"
                (click)="onCreateKey(keyName.value)"
                size="small"
                variant="standard"
                color="tertiary"
                text="Create"
              ></hyperkit-button>
            </form>
          } @else {
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="primary"
              >The maximium number of keys has been reached, remove a key below
              to create a new key.</hyperkit-typography
            >
          }
        </div>
        <div class="keys">
          <hyperkit-typography
            display="block"
            variant="h4"
            align="left"
            color="primary"
            >Created Keys</hyperkit-typography
          >
          <kendo-grid
            [data]="apiKeys.keys"
            kendoGridSelectBy="id"
            [pageSize]="20"
            [pageable]="false"
            [sortable]="false"
            [groupable]="false"
            [selectable]="false"
            [reorderable]="false"
            [resizable]="true"
          >
            <kendo-grid-column field="name" title="Name">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.name }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdAt" title="Created">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.createdAt | date: 'short' }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
              [width]="100"
              [sortable]="false"
              field="id"
              title="Delete"
            >
              <ng-template kendoGridCellTemplate let-dataItem>
                <hyperkit-button
                  (click)="onRemoveKey(dataItem.id)"
                  size="small"
                  variant="icon"
                  icon="trash"
                  color="secondary"
                ></hyperkit-button>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
    } @else {
      <kendo-loader type="pulsing" themeColor="primary" size="large">
      </kendo-loader>
    }
  </div>
</div>
